export default __webpack_public_path__ + "static/media/Annexures.ab0d53bf.svg";